/**
 * Avalara © 2017
 * file: engines/opus_ui/src/containers/LoggedInContainer.jsx
 */

import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import config from '../config';
import { loginUserSuccess } from '../actions/auth';
import loadingGif from '../assets/loading.gif';
import { getBaseUrlFromConfig } from '../utils/url_helpers';
// import AddNewProduct from '../addNewProduct/addNewProduct';
import Search from './SearchContainer';
import Status from './StatusContainer';
import CreateCustomer from '../customer/CreateCustomer';
import Logout from '../logout/Logout';
// import NewProduct from '../newProduct/newProduct';
import SellOffers from '../sellOffers/sellOffers';
import SwaggerDisplay from '../SwaggerDisplay';
// import UsageSearch from '../usage/UsageSearch';
// import UsageStatus from '../usage/UsageStatus';
// import UsageDetails from '../usage/UsageDetails';
// import SandboxProvisioning from '../sandboxProvisioning/SandboxProvisioning';
import CorrelationLogTable from '../centralizedLogger/CorrelationLogTable';
import Utility from '../accountUsage/Utility';
import { withRouter } from './WithRouter';
import IamDetailsComponent from '../IamDetails/IamDetailsComponent';
import ReprovAgingReport from '../report/ReprovAgingReport';

const baseUrl = getBaseUrlFromConfig(config.biztechApi);

function getUrlHashFragment() {
  return window.location.hash;
}

function isOnLogoutPage() {
  return getUrlHashFragment()
    .toLowerCase()
    .includes('logout');
}

async function forceLoginIfLoggedOut(dispatch) {
  try {
    await axios.get(`${baseUrl}/default/isAuthenticated`);

    dispatch(loginUserSuccess());
  } catch (error) {
    // console.error(error.message);
  }
}

class LoggedInContainer extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    if (isOnLogoutPage()) {
      return;
    }
    forceLoginIfLoggedOut(dispatch);
  }

  render() {
    if (this.props.auth.isAuthenticated || isOnLogoutPage()) {
      return (
        <div>
          <Routes>
            <Route exact path="/delivery" Component={Search} />
            <Route exact path="/search" Component={Search} />
            <Route exact path="/swagger" Component={SwaggerDisplay} />
            <Route exact path="/status" Component={Status} />
            {/* <Route exact path="/new-product" Component={NewProduct} />
            <Route exact path="/add-new-product" Component={AddNewProduct} /> */}
            <Route exact path="/sell-offers" Component={SellOffers} />
            <Route exact path="/create-customer" Component={CreateCustomer} />
            {/* <Route exact path="/usage-search" Component={UsageSearch} />
            <Route exact path="/usage-status" Component={UsageStatus} />
            <Route exact path="/usage-details" Component={UsageDetails} />
            <Route
              exact
              path="/sandbox-provisioning"
              Component={SandboxProvisioning}
            /> */}
            <Route
              exact
              path="/logs/correlation"
              Component={CorrelationLogTable}
            />
            <Route
              exact
              path="/logs/correlation/:id"
              Component={CorrelationLogTable}
            />
            <Route exact path="/organization" Component={IamDetailsComponent} />
            <Route
              exact
              path="/organization/:id"
              Component={IamDetailsComponent}
            />
            <Route
              exact
              path="/organizationSandbox"
              Component={IamDetailsComponent}
            />
            <Route
              exact
              path="/organizationSandbox/:id"
              Component={IamDetailsComponent}
            />
            <Route exact path="/utility" Component={Utility} />
            <Route exact path="/utility/:name" Component={Utility} />
            <Route
              exact
              path="/reports/reprov-aging-report"
              Component={ReprovAgingReport}
            />
            <Route exact path="/logout" Component={Logout} />
            <Route exact path="/" Component={Search} />
          </Routes>
        </div>
      );
    } else {
      return (
        <div className="mt-100">
          <img src={loadingGif} alt="loading..." />
          <h1>Please wait...</h1>
        </div>
      );
    }
  }
}

export default withRouter(connect(({ auth }) => ({ auth }))(LoggedInContainer));
